<template>
  <div class="page">
    <div class="head">
      <img width="100%" src="../assets/cp-8.jpg" alt="">
      <div class="des">
        <div class="title">软件系统类</div>
        <div class="text">以更简单的方式协同工作，快速获取意想不到的新洞察，并提供<br>改变业务的结果</div>
        <div class="icon">
          <Icon style="padding-right: 10px" size="16" type="md-arrow-forward" />联系INCO获取更多信息
        </div>
      </div>
    </div>

    <!-- v-if="data.length > 0" -->
    <div class="content">
      <div class="c1" ref="backTop1">
        <div class="title">{{titles[0]}}</div>
        <div class="items">
          <div class="item" v-for="(item,index) of c1Data" :key="index" @click="goImage(item.img)">
            <div class="title">{{item.title}}</div>
            <img src="../assets/row.png" class="icon" />
          </div>
        </div>
      </div>
      <div class="c2" ref="backTop2">
        <div class="title">{{titles[1]}}</div>
        <div class="items">
          <div v-for="(list,index) of c2Data" :key="index">
            <div class="container" style="width: 100%;" v-if="index % 2 == 0">
              <div class="col" v-for="(items,index1) of list" :key="index1">
                <div style="display: flex;">
                  <img class="item_img" :src="getBgImage(index1)" />
                  <div class="item_content">
                    <div class="ci" v-for="(item,index2) of items" :key="index2" @click="goImage(item.img)">
                      <div class="title">{{item.title}}</div>
                      <img src="../assets/row.png" class="icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container" v-else>
              <div class="col" v-for="(items,index1) of list" :key="index1">
                <div style="display: flex;">
                  <div class="item_content">
                    <div class="ci" v-for="(item,index2) of items" :key="index2" @click="goImage(item.img)">
                      <div class="title">{{item.title}}</div>
                      <img src="../assets/row.png" class="icon" />
                    </div>
                  </div>
                  <img class="item_img" :src="getBgImage1(index1)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="c3" ref="backTop3">
        <div class="title">{{titles[2]}}</div>
        <div class="items">
          <div class="item" v-for="(item,index) in c3Data" :key="index" :style="getPjStyle(index)" @click="goImage(item.img)">
            <div class="title">{{item.title}}</div>
            <img class="image" :src="getPjImage(index+1)" />
            <img src="../assets/row.png" class="icon" />
          </div>
        </div>
      </div>
    </div>
    <div class="foot" ref="backTop4">
      <div class="content">
        <img class="image" src="../assets/cp-9.jpg" />
        <div class="right">
          <div class="title">{{titles[3]}}</div>
          <div class="item_content">
            <div class="ci" v-for="(item,index) of c4Data" :key="index" @click="goImage(item.img)">
              <div class="title">{{item.title}}</div>
              <img src="../assets/row.png" class="icon" />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      topHeight: 0,
      data: [],
      titles: ['课程资源', '教学业务系统', '评价管理系统', '其他业务'],
      c1Data: [
        { title: 'MOOC平台', img: '' },
        { title: '网络考试训练系统', img: '' },
        { title: '掌上教学应用', img: '' },
        { title: '教学质量状态数据库', img: '' },
      ],
      c2Data: [
        [
          [
            { title: '普通高校教学一体化业务管理系统', img: '' },
            { title: '职业院校教学诊改一体化平台', img: '' },
            { title: '课程申报评审系统', img: '' },
            { title: '排课系统', img: '' },
          ],
          [
            { title: '教材管理系统', img: '' },
            { title: '教学媒体资源管理系统', img: '' },
            { title: '毕业设计及论文管理系统', img: '' },
            { title: '大学生创新创业计划管理系统', img: '' },
          ],
        ],
        [
          [
            { title: '大学生学科竞赛项目管理系统', img: '' },
            { title: '实验实践教学管理系统', img: '' },
            { title: '国内国际合作交流项目管理系统', img: '' },
            { title: '教学项目管理系统', img: '' },
          ],
          [
            { title: '教学经费管理系统', img: '' },
            { title: '专业选择系统', img: '' },
            { title: '国际专业认证平台', img: '' },
            { title: '顶岗实习系统', img: '' },
          ],
        ],
      ],
      c3Data: [
        { title: '课程质量评价系统', img: '' },
        { title: '学生选拔培养管理系统', img: '' },
        { title: '第二学分认定系统', img: '' },
        { title: '综合评教管理系统', img: '' },
        { title: '教学工作量统计管理系统', img: '' },
        { title: '教师发展管理系统', img: '' },
        { title: '助教管理系统', img: '' },
        { title: '大学英语实验评估系统', img: '' },
      ],
      c4Data: [
        { title: '学工信息管理系统', img: '' },
        { title: '教务OA系统', img: '' },
        { title: '其他业务', img: '' },
      ],
      b1Data: [
        '普通高校教学一体化业务管理系统',
        '职业院校教学诊改一体化平台',
        '课程申报评审系统',
        '排课系统',
      ],
      b2Data: [
        '教材管理系统',
        '教学媒体资源管理系统',
        '毕业设计及论文管理系统',
        '大学生创新创业计划管理系统',
      ],
      b3Data: [
        '大学生学科竞赛项目管理系统',
        '实验事件教学管理系统',
        '国内国际合作交流项目管理系统',
        '教学项目管理系统',
      ],
      b4Data: ['教学经费管理系统', '专业选择系统', '国际专业认证平台', '顶岗实习系统'],
    }
  },
  methods: {
    getBgImage(index) {
      return require('../assets/cp-' + (11 + index) + '.jpg')
    },
    getBgImage1(index) {
      return require('../assets/cp-' + (13 + index) + '.jpg')
    },
    getPjImage(index) {
      return require('../assets/cp-0' + (index > 8 ? index % 8 : index) + '.png')
    },
    getPjStyle(index) {
      let size = this.c3Data.length % 3
      if (size === 0) size = 3
      for (let i = 1; i < size + 1; i++) {
        if (index == this.c3Data.length - i) {
          return 'border-bottom:none'
        }
      }
      return ''
    },
    // goToNewPage(path) {
    //   this.$router.push(path)
    // },
    //判断字符是否为空的方法
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    goImage(item) {
      if (!this.isEmpty(item)) {
        window.open(item)
      }
    },
    arrayResolve(n, arr) {
      let result = []
      for (let i = 0; i < arr.length; i += n) {
        result.push(arr.slice(i, i + n))
      }
      return result
    },
    handleScroll() {
      this.topHeight = this.$refs.backTop.getBoundingClientRect().top
      console.log(this.topHeight)

      console.log('滚动高度', window.pageYOffset)
      console.log('距离顶部高度', this.$refs.backTop.getBoundingClientRect().top)
    },
  },
  created() {
    let url1 =
      this.HOST +
      'inconWeb/getMenuListByParentId?moduleOrder=ordernum&contentOrder=ordernum&websiteid=4&parentid=C839903BBE8909FAE05509994F3826F5'

    url1 = this.$getJsonUrl(url1)
    this.$axios.get(url1).then((res) => {
      let data = res.data.content.list[1].children[0]

      this.c1Data = data.children[0].list
      //数组分解
      let array = data.children[1].list
      let array1 = this.arrayResolve(8, array)
      for (const item of array1) {
        this.c2Data.push(this.arrayResolve(4, item))
      }
      this.c3Data = data.children[2].list
      this.c4Data = data.children[3].list
      this.titles = [
        data.children[0].title,
        data.children[1].title,
        data.children[2].title,
        data.children[3].title,
      ]
    })

    this.currentIndex = this.$route.query.currentIndex
    this.title = this.$route.query.title
  },
  mounted() {
    console.log(this.currentIndex)

    // 滚动条的获取
    // window.addEventListener('scroll', this.handleScroll, true)
    this.$nextTick(() => {})

    setTimeout(() => {
      if (this.currentIndex == 0) {
        this.topHeight = this.$refs.backTop1.getBoundingClientRect().top
      } else if (this.currentIndex == 1) {
        this.topHeight = this.$refs.backTop2.getBoundingClientRect().top
      } else if (this.currentIndex == 2) {
        this.topHeight = this.$refs.backTop3.getBoundingClientRect().top
      } else {
        this.topHeight = this.$refs.backTop4.getBoundingClientRect().top
      }
      console.log(this.topHeight)
      document.documentElement.scrollTop = this.topHeight - 60
    }, 100)
  },
  beforeDestroy() {
    // window.removeEventListener('scroll', this.handleScroll, true)
  },
}
</script>

<style scoped lang="less">
.page {
  .head {
    position: relative;

    .des {
      position: absolute;
      left: 50%;
      bottom: 30px;
      transform: translateX(-50%);
      width: 60%;
      min-width: 1000px;
      max-width: 1200px;
      color: #fff;

      .title {
        font-size: 18px;
        font-weight: 600;
        line-height: 30px;
      }

      .text {
        padding-bottom: 10px;
        font-size: 14px;
        line-height: 20px;
      }

      .icon {
        font-size: 12px;
      }
    }
  }

  .content {
    margin: 20px auto;
    width: 60%;
    min-width: 1000px;

    .title {
      font-size: 18px;
      width: 200px;
      color: #606060;
    }

    .c1 {
      display: flex;

      .items {
        flex: 1;
        display: flex;
        flex-flow: wrap;

        .item {
          margin: 2px;
          height: 80px;
          width: calc(50% - 4px);
          background-color: #e9ebee;
          position: relative;

          .title {
            font-size: 15px;
            margin: 5px 10px;
            width: calc(100% - 70px);
            height: 25px;
            overflow: hidden;
          }

          .icon {
            position: absolute;
            right: 20px;
            bottom: 20px;
          }
        }
      }
    }

    .c2 {
      margin-top: 50px;
      .items {
        margin-top: 20px;
        .container {
          width: 100%;
          .col {
            width: 50%;
            display: inline-block;
          }
        }
        .item_img {
          margin: 2px;
          height: 260px;
          width: 246px;
          background-image: url(../assets/cp-11.jpg);
          background-size: 100% 100%;
        }
        .item_content {
          margin: 2px;
          width: 246px;
          height: 260px;
          .ci {
            height: 61px;
            background-color: #e9ebee;
            position: relative;
            margin-bottom: 5px;

            .title {
              font-size: 14px;
              padding: 10px;
            }

            .icon {
              position: absolute;
              right: 10px;
              bottom: 5px;
            }
          }
        }
      }
    }

    .line {
      margin-top: 20px;
      width: 100%;
      height: 1px;
      background-color: #d0d0d0;
    }

    .c3 {
      margin-top: 50px;
      display: flex;

      .items {
        flex: 1;
        display: flex;
        flex-flow: wrap;

        .item {
          width: 33%;
          position: relative;
          margin-bottom: 10px;
          border-bottom: 1px solid #d0d0d0;

          .title {
            font-size: 14px;
          }

          .image {
            margin-top: 10px;
            width: 110px;
          }

          .icon {
            position: absolute;
            right: 20px;
            bottom: 10px;
          }
        }
      }
    }
  }

  .foot {
    height: 400px;
    background-color: #e9ebee;

    .content {
      width: 60%;
      min-width: 1000px;
      display: flex;

      .image {
        height: 400px;
      }

      .title {
        margin: 20px;
        font-size: 18px;
        width: 200px;
        color: #606060;
      }

      .right {
        .item_content {
          margin-top: 43px;

          .ci {
            width: 200px;
            height: 100px;
            background-color: #ffffff;
            position: relative;
            margin-top: -10px;

            .title {
              font-size: 14px;
              padding: 10px;
            }

            .icon {
              position: absolute;
              right: 10px;
              bottom: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
